module.exports = __webpack_public_path__ + "static/gift-dd99e9c8eb9ec3f9c0c075a9a9fbae74.png";